import { render, staticRenderFns } from "./mySj.vue?vue&type=template&id=944a96ea&scoped=true"
import script from "./mySj.vue?vue&type=script&lang=js"
export * from "./mySj.vue?vue&type=script&lang=js"
import style0 from "./mySj.vue?vue&type=style&index=0&id=944a96ea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "944a96ea",
  null
  
)

export default component.exports